import { useFeatureFlags } from '@/hooks/useFeatureFlag';
import { Box, useMediaQuery as useMuiMediaQuery } from '@mui/material';
import { FeatureFlag } from '@shared/enums';
import { ReactNode } from 'react';
import { getBrandTint } from './brandTint';
import { PhoneFrame } from './PhoneFrame';

// A literal query, not theme breakpoints: retailer-branded themes drop the app's custom values.
const frameMinWidthQuery = '(min-width: 906px)';

interface DashboardDesktopShellProps {
  brandColor?: string | null,
  children: ReactNode,
}

export const DashboardDesktopShell = ({ brandColor, children }: DashboardDesktopShellProps) => {
  const tint = getBrandTint(brandColor);
  const { isFlagOn } = useFeatureFlags();
  const isWideScreen = useMuiMediaQuery(frameMinWidthQuery);
  // Inside the phone's embedded window the dashboard renders normally, never another frame.
  const isEmbedded = window.self !== window.top;

  if (isFlagOn(FeatureFlag.DashboardDesktopFrame) && isWideScreen && !isEmbedded) {
    return <PhoneFrame tint={tint} />;
  }

  return (
    <Box
      data-testid="crd-desktop-shell"
      sx={{ bgcolor: tint ?? 'background.default', minHeight: '100vh' }}
    >
      <Box data-testid="crd-column" sx={{ maxWidth: '599px', mx: 'auto', width: '100%' }}>
        {children}
      </Box>
    </Box>
  );
};
